{
  "name": "hck.nws",
  "version": "5.4.2",
  "private": true,
  "license": "MIT",
  "homepage": "https://carlos-aguilar.com/hck.nws",
  "browserslist": "> 0.5%, last 2 versions, not dead",
  "source": [
    "src/index.html",
    "src/404.html"
  ],
  "targets": {
    "default": {
      "publicUrl": "/hck.nws/"
    }
  },
  "scripts": {
    "start": "parcel",
    "build": "parcel build --no-cache",
    "clean": "rm -r dist .parcel-cache parcel-bundle-reports"
  },
  "dependencies": {
    "@fontsource/outfit": "^4.5.11",
    "@material-ui/core": "^4.12.4",
    "@material-ui/icons": "^4.11.3",
    "@material-ui/lab": "^4.0.0-alpha.61",
    "@parcel/service-worker": "^2.8.3",
    "@reduxjs/toolkit": "^1.9.3",
    "axios": "^0.27.2",
    "clsx": "^1.2.1",
    "notistack": "^1.0.10",
    "prop-types": "^15.8.1",
    "react": "^18.2.0",
    "react-dom": "^18.2.0",
    "react-helmet-async": "^1.3.0",
    "react-redux": "^8.0.5",
    "react-router-dom": "^6.8.2"
  },
  "devDependencies": {
    "@parcel/packager-raw-url": "2.8.3",
    "@parcel/reporter-bundle-analyzer": "^2.8.3",
    "@parcel/transformer-svg-react": "^2.8.3",
    "@parcel/transformer-webmanifest": "2.8.3",
    "buffer": "^6.0.3",
    "parcel": "^2.8.3",
    "prettier": "^2.8.4",
    "process": "^0.11.10",
    "redux-logger": "^3.0.6"
  }
}
